// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"68e6e1d7","455":"1b0a6a6b","680":"22f8296e","708":"3c61871f","977":"b584b783"}[chunkId] + ".chunk.js";
};